import { Component, ViewChild } from '@angular/core';
import { ViewController, Events, PopoverController, Platform } from 'ionic-angular';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import moment from 'moment';
import { LocationsProvider } from '../../providers/locations/locations';
import { EventsProvider } from '../../providers/events/events';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { CoDateTimePickerPopoverComponent } from '../co-date-time-picker-popover/co-date-time-picker-popover';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { AppState } from '../../config/state';
import { CoCalendarComponent } from '../co-calendar/co-calendar';
// import { CoEventsExploreComponent } from '../co-events-explore/co-events-explore';
/**
 * Generated class for the CoPopoverEventsFilterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-popover-events-filter',
  templateUrl: 'co-popover-events-filter.html'
})
export class CoPopoverEventsFilterComponent {
  @ViewChild(CoCalendarComponent) innerCalendar: CoCalendarComponent;
  fromDate: any;
  toDate: any;
  fromDateElement: any;
  toDateElement: any;
  calendarLine: Array<string> = [];
  filterShow: string;
  filterShowMobile: string;
  text: string;
  timeRange: { lower: { hour: number, minute: number }, upper: { hour: number, minute: number } } = { lower: { hour: 0, minute: 0 }, upper: { hour: 24, minute: 0 } };
  dateRange: { lower: any, upper: any } = { lower: moment(), upper: moment() };
  displayTime: any;
  rangeBarTime: { lower: number, upper: number } = { lower: 0, upper: 96 };
  displayDate: any;
  allLocations: any;
  includedLocations: any = {};
  currentDate: any;
  eventAges: any;
  includedAges: any = {};
  eventTypes: any;
  includedTypes: any = {};
  filterKeyword: any;
  currentFilters: any;
  keywordTextValue: string;
  presetTimings: string;
  isTimeApplied: boolean = false;
  isDateRangeApplied: boolean = false;
  locationArrayForDisplay: Array<any> = [];
  agesArrayForDisplay: Array<any> = [];
  typesArrayForDisplay: Array<any> = [];
  toggleAllLocations: boolean = true;
  toggleAllAges: boolean = true;
  toggleAllTypes: boolean = true;
  platformType: boolean;
  appliedFilters: any;
  constructor(public viewCtrl: ViewController, public navParams: NavParams, public locationsProvider: LocationsProvider, public eventsProvider: EventsProvider, private events: Events, private timeout: TimeoutFunctionsProvider, private popoverCtrl: PopoverController, private sounds: SoundsProvider, private state: AppState, private platform: Platform) {
    this.platformType = this.platform.is('cordova');
    this.events.subscribe('timeoutCalled', () => this.timeout.doLogoutFunctions(this));
    this.filterShow = "location";
    this.filterShowMobile = "location";
    let appliedFilters = this.navParams.data.current;
    this.appliedFilters = this.navParams.data.current;
    this.currentDate = this.navParams.data.date;
    if (appliedFilters.date && !appliedFilters.date.lower.isSame(appliedFilters.date.upper)) {
      this.dateRange.lower = appliedFilters.date.lower;
      this.dateRange.upper = appliedFilters.date.upper;
      this.isDateRangeApplied = true;
    }
    locationsProvider.getLocations().then((res) => {
      this.allLocations = res;
      if (appliedFilters.location && appliedFilters.location.length !== this.allLocations.length) {
        this.allLocations.forEach(loc => {
          if (appliedFilters.location && appliedFilters.location.includes(loc.id.toString())) {
            this.includedLocations[loc.id] = true;
            this.locationArrayForDisplay.push(this.includedLocations[loc.id]);
          } else {
            this.includedLocations[loc.id] = false;
          }
        });
        this.setLocations(false);
      }
    });
    eventsProvider.getEventAgesTypes().then((res) => {
      this.eventAges = res.ages;
      if (appliedFilters.ages && appliedFilters.ages.length !== res.ages.length) {
        this.eventAges.forEach(age => {
          if (appliedFilters.ages && appliedFilters.ages.includes(age.name)) {
            this.includedAges[age.name] = true;
            this.agesArrayForDisplay.push(this.includedAges[age.name]);
          } else {
            this.includedAges[age.name] = false;
          }
        });
        this.setAges(false);
      }
      this.eventTypes = res.types;
      if (appliedFilters.eventType && appliedFilters.eventType.length !== res.types.length) {
        this.eventTypes.forEach(eventType => {
          if (appliedFilters.eventType && appliedFilters.eventType.includes(eventType.name)) {
            this.includedTypes[eventType.name] = true;
            this.typesArrayForDisplay.push(this.includedTypes[eventType.name]);
          } else {
            this.includedTypes[eventType.name] = false;
          }
        });
        this.setEventType(false);
      }
    });
    this.keywordTextValue = appliedFilters.keyword;
    if (appliedFilters.time && (appliedFilters.time.lower.hour !== 0 || appliedFilters.time.lower.minute !== 0 || appliedFilters.time.upper.hour !== 24 || appliedFilters.time.upper.minute !== 0)) {
      // console.log(appliedFilters);
      this.timeRange.lower.hour = appliedFilters.time.lower.hour;
      this.timeRange.lower.minute = appliedFilters.time.lower.minute;
      this.timeRange.upper.hour = appliedFilters.time.upper.hour;
      this.timeRange.upper.minute = appliedFilters.time.upper.minute;
      this.rangeBarTime.lower = (appliedFilters.time.lower.hour * 4) + (Math.floor(appliedFilters.time.lower.minute / 15));
      this.rangeBarTime.upper = (appliedFilters.time.upper.hour * 4) + (Math.floor(appliedFilters.time.upper.minute / 15));
      this.isTimeApplied = true;
    } else {
      this.rangeBarTime.lower = 0;
      this.rangeBarTime.upper = 96;
    }

    this.displayTime = { lower: moment().hour(this.timeRange.lower.hour).minute(this.timeRange.lower.minute), upper: moment().hour(this.timeRange.upper.hour).minute(this.timeRange.upper.minute) };
    // this.rangeBarTime.lower = (this.displayTime.lower.hour() * 4) + (Math.floor(this.displayTime.lower.minute()/15));
    // if (this.displayTime.upper.hour === '24' && this.range){this.rangeBarTime.upper = (this.displayTime.upper.hour * 4) + (Math.floor(this.displayTime.upper.minute/15));}
    this.displayDate = this.dateRange;
  };

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
    this.monthClicked(this.currentDate);
  }

  ionViewDidLoad(){
  }

  monthClicked(dateString: string) {
    let startDate = moment(dateString).startOf('day').format("YYYY-MM-DD");
    let endDate = moment(dateString).endOf('day').format("YYYY-MM-DD");
    // let newMonthQuery = `startDate: "${startDate}", endDate: "${endDate}"`;
    // this.queryEvents(newMonthQuery);
    if (this.innerCalendar)this.innerCalendar.goToMonth(dateString);
    // this.innerCalendar.loadMonthEvents(this.monthEvents);
    // this.updateEvents(moment(dateString)); Already being done by this.queryEvents(newMonthQuery);
    this.calendarLoad(dateString);
    // this.eventQueryTimeArgs.emit({ start: moment(startDate).format("YYYY-MM-DD HH:mm:ss"), end: moment(endDate).format("YYYY-MM-DD HH:mm:ss") });
  }

  nextMonths(date: string) {
    let selectedDate = moment(date).startOf('month').add(5, 'month').format("YYYY-MM-DD HH:mm:ss");

    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'month').format("YYYY-MM-DD HH:mm:ss"));
    }
    selectedDate = moment(selectedDate).add(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.monthClicked(selectedDate);
  }

  previousMonths(date: string) {
    let selectedDate = moment(date).startOf('month').subtract(5, 'month').format("YYYY-MM-DD HH:mm:ss");

    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'month').format("YYYY-MM-DD HH:mm:ss"));
    }
    selectedDate = moment(selectedDate).add(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.monthClicked(selectedDate);
  }

  calendarLoad(date: string) {
    let selectedDate = moment(date).startOf('month').subtract(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).startOf('month').add(x, 'month').format("YYYY-MM-DD HH:mm:ss"))
    };
  };

  // changeRange(event, timing) {
  //   this.timeRange.lower = timing.stats[0];
  //   this.timeRange.upper = timing.stats[1];
  //   this.onChange("");
  // };
  openDateRangePopup(myEvent, endpoint) {
    let popover = this.popoverCtrl.create(CoDateTimePickerPopoverComponent, { screen: 'date', currentFilters: this.dateRange, rangePoint: endpoint }, { cssClass: 'date-time-popover' });
    popover.present({
      ev: myEvent
    });

    popover.onDidDismiss(data => {
      if (data) {
        this.dateRange[endpoint] = data;
      }
      this.setDate();
    });
  }

  updateEvents(event) {
    // let startDate = event.fromDate.format("YYYY-MM-DD");
    // let endDate = event.toDate.format("YYYY-MM-DD");
    let startDate, endDate;
    // console.log(event);
    event.fromDate ? startDate = event.fromDate : false;
    event.toDate ? endDate = event.toDate : false;
    this.dateRange.lower = startDate;
    this.dateRange.upper = endDate;
    // if (!event.toDate) {
    //   this.toDate = '';
    //   return;
    // }
    // let newMonthQuery = `startDate: "${startDate}", endDate: "${endDate}"`;
    // this.queryEvents(newMonthQuery);
    // this.eventQueryTimeArgs.emit({ start: event.fromDate.format("YYYY-MM-DD 00:00:00"), end: event.toDate.endOf('day').format("YYYY-MM-DD HH:mm:ss") });
    this.setDate();
  }


  resetCalendar() {
    this.innerCalendar.resetCalendar();
    this.updateEvents({});
  }

  openTimeRangePopup(myEvent, endpoint) {
    let popover = this.popoverCtrl.create(CoDateTimePickerPopoverComponent, { screen: 'time', currentFilters: this.timeRange, rangePoint: endpoint }, { cssClass: 'date-time-popover' });
    popover.present({
      ev: myEvent
    });

    popover.onDidDismiss(data => {
      if (data) {
        this.presetTimings = null;
        if (data.hour === '12') data.hour = 0;
        if (data.period === 'pm') data.hour = Number(data.hour) + 12;
        // console.log(data, endpoint);
        if (endpoint === 'lower') {
          this.timeRange.lower.hour = data.hour;
          this.timeRange.lower.minute = data.minute;
        } else {
          this.timeRange.upper.hour = data.hour;
          this.timeRange.upper.minute = data.minute;
        }
        this.setTime();
      }
    });
  }

  setPresetTime() {
    if (this.presetTimings === 'morning') {
      this.timeRange.lower.hour = 0;
      this.timeRange.lower.minute = 0;
      this.timeRange.upper.hour = 12;
      this.timeRange.upper.minute = 0;
      this.setTime();     //THIS IS CALLED IN HERE OR ELSE IT WOULD ALWAYS BE CALLED
    } else if (this.presetTimings === 'afternoon') {
      this.timeRange.lower.hour = 12;
      this.timeRange.lower.minute = 0;
      this.timeRange.upper.hour = 18;
      this.timeRange.upper.minute = 0;
      this.setTime();
    } else if (this.presetTimings === 'night') {
      this.timeRange.lower.hour = 17;
      this.timeRange.lower.minute = 0;
      this.timeRange.upper.hour = 24;
      this.timeRange.upper.minute = 0;
      this.setTime();
    }
  }

  resetTime() {
    // this.timeRange.lower = 0;
    // this.timeRange.upper = 24;
    this.timeRange = {
      lower: { hour: 0, minute: 0 },
      upper: { hour: 24, minute: 0 }
    }
    this.presetTimings = null;
    this.setTime();
  }

  setTime() {
    this.displayTime.lower = moment().hour(this.timeRange.lower.hour).minute(this.timeRange.lower.minute);
    this.displayTime.upper = moment().hour(this.timeRange.upper.hour).minute(this.timeRange.upper.minute);

    this.rangeBarTime = {
      lower: (this.timeRange.lower.hour * 4) + (Math.floor(this.timeRange.lower.minute / 15)),
      upper: (this.timeRange.upper.hour * 4) + (Math.floor(this.timeRange.upper.minute / 15))
    }

    // console.log(this.displayTime, this.rangeBarTime)
    if (this.timeRange.lower.hour === 0 && this.timeRange.lower.minute === 0 && this.timeRange.upper.hour === 24 && this.timeRange.upper.minute === 0) {
      this.isTimeApplied = false;
    } else {
      this.isTimeApplied = true;
    }
  }

  resetDate() {
    if (this.isDateRangeApplied === true) {
      this.dateRange.lower = moment();
      this.dateRange.upper = moment();
      this.isDateRangeApplied = false;
    }
  }

  setDate() {
    this.displayDate.lower = this.dateRange.lower;
    this.displayDate.upper = this.dateRange.upper;
    if (this.dateRange.lower && this.dateRange.upper) {
      if ((this.dateRange.lower.isSame(moment(), 'day') && this.dateRange.upper && this.dateRange.upper.isSame(moment(), 'day')) || this.dateRange.lower.isAfter(this.dateRange.upper, 'day')) {
        this.isDateRangeApplied = false;
      } else {
        this.isDateRangeApplied = true;
      }
    } else {
      this.isDateRangeApplied = false;
    }
  }

  setKeyword(event) {
    if (event.target && event.target.value.length > 0) {
      this.filterKeyword = event.target.value.toLowerCase();
    } else {
      this.filterKeyword = "";
    }
  }

  setLocations(all, reset?) {
    let locationArray = [];
    if (!all) {
      for (let location in this.includedLocations) {
        this.includedLocations[location] === true ? locationArray.push(location) : false;
      };
      if (locationArray.length <= 0) {
        for (let location in this.includedLocations) {
          locationArray.push(location);
        };
        this.locationArrayForDisplay = [];
        this.toggleAllLocations = true;
      } else {
        this.locationArrayForDisplay = locationArray;
        this.toggleAllLocations = false;
      }
    } else if (all) {
      if (reset) {
        Object.keys(this.includedLocations).forEach((location) => {
          this.includedLocations[location] = false;
        })
        this.locationArrayForDisplay = [];

      } else {
        for (let location in this.includedLocations) {
          locationArray.push(location);
        };
        this.locationArrayForDisplay = locationArray;
      }
    } else {
      console.log('you should not see this, something wrong with location list');
    }
  }

  setAges(all, reset?) {
    let ageArray = [];
    if (!all) {
      for (let age in this.includedAges) {
        this.includedAges[age] === true ? ageArray.push(age) : false;
      };
      this.agesArrayForDisplay = ageArray;
      if (ageArray.length <= 0) {
        for (let age in this.includedAges) {
          ageArray.push(age);
        };
        this.agesArrayForDisplay = [];
        this.toggleAllAges = true;
      } else {
        this.agesArrayForDisplay = ageArray;
        this.toggleAllAges = false;
      }
    } else if (all) {
      if (reset) {
        Object.keys(this.includedAges).forEach((ageGroup) => {
          this.includedAges[ageGroup] = false;
        })
        this.agesArrayForDisplay = [];
      } else {
        for (let age in this.includedAges) {
          ageArray.push(age);
        };
        this.agesArrayForDisplay = ageArray;
      }
    } else {
      console.log('you should not see this, something wrong with ages list');
    }
  }

  setEventType(all, reset?) {
    let eventTypeArray = [];
    if (!all) {
      for (let eventType in this.includedTypes) {
        this.includedTypes[eventType] === true ? eventTypeArray.push(eventType) : false;
      };
      this.typesArrayForDisplay = eventTypeArray;
      if (eventTypeArray.length <= 0) {
        for (let eventType in this.includedTypes) {
          eventTypeArray.push(eventType)
        };
        this.typesArrayForDisplay = [];
        this.toggleAllTypes = true;
      } else {
        this.typesArrayForDisplay = eventTypeArray;
        this.toggleAllTypes = false;
      }
    } else if (all) {
      if (reset) {
        Object.keys(this.includedTypes).forEach((type) => {
          this.includedTypes[type] = false;
        })
        this.typesArrayForDisplay = [];
      } else {
        for (let eventType in this.includedTypes) {
          eventTypeArray.push(eventType)
        };
        this.typesArrayForDisplay = eventTypeArray;
      }
    } else {
      console.log('you should not see this, something wrong with event type list')
    }
  }

  resetAll(event) {
    if (this.platform.is('cordova')) this.close("resetAll", "", false);
  }

  close(tab, info, active) {
    let filterObj = {
      location: this.locationArrayForDisplay,
      ages: this.agesArrayForDisplay,
      eventType: this.typesArrayForDisplay,
      time: this.timeRange,
      date: this.dateRange
    };
    if (filterObj.location.length <= 0 && filterObj.ages.length <= 0 && filterObj.eventType.length <= 0 && filterObj.time.lower.hour === 0 && filterObj.time.lower.minute === 0 && filterObj.time.upper.hour === 24 && filterObj.time.upper.minute === 0 && filterObj.date.lower.isSame(filterObj.date.upper, 'day') && filterObj.date.lower.isSame(moment(), 'day')) { // THIS CHEKCS ALL THE FIELDS FOR DIFFERENCES FROM DEFAULT
      this.viewCtrl.dismiss();
    } else {
      if (!this.platform.is('cordova')) this.viewCtrl.dismiss({ type: "", stats: filterObj, on: active }).catch(err => { });
      if (this.platform.is('cordova')) {
        this.events.publish('setAttendFilters', { type: "", stats: filterObj, on: active });
        this.viewCtrl.dismiss();
      }
    }
  };

  onChange(event) {
    let hourLower = Math.floor(this.rangeBarTime.lower / 4);
    let minuteLower = this.rangeBarTime.lower % 4 * 15;
    let hourUpper = Math.floor(this.rangeBarTime.upper / 4);
    let minuteUpper = this.rangeBarTime.upper % 4 * 15;
    this.displayTime = { lower: moment().hour(hourLower).minute(minuteLower), upper: moment().hour(hourUpper).minute(minuteUpper) }
    this.timeRange.lower = { hour: hourLower, minute: minuteLower };
    this.timeRange.upper = { hour: hourUpper, minute: minuteUpper };
  };

  sendFilterEvent() {

  }


}



// WEBPACK FOOTER //
// ./src/components/co-popover-events-filter/co-popover-events-filter.ts